export default "__VITE_ASSET__B1iN5F_O__"